import { useQuery } from "@tanstack/react-query";

import { apiClient } from "@/api/client";

import { toTimelineLogEntry } from "../lib/timeline-vm";

/**
 * GET /v1/orders/{id}/logs/timeline — Lifecycle transition history for one
 * order, newest first (backend order_status_timeline).
 */
export function useTimelineLog(orderId: string) {
  return useQuery({
    queryKey: ["order", orderId, "timeline-log"],
    enabled: !!orderId,
    queryFn: async () => {
      const { data, error } = await apiClient.GET("/v1/orders/{id}/logs/timeline", {
        params: { path: { id: orderId } },
      });
      if (error) throw error;
      return (data?.data ?? []).map((r) => toTimelineLogEntry(r));
    },
  });
}
